import device from '@service-victoria/component-library/utils/device';
import GlobalStyle from 'globalStyles';
import React from 'react';
import { Helmet } from 'react-helmet';
import { ReactQueryDevtools } from 'react-query/devtools';
import styled, { ThemeProvider } from 'styled-components';

import CustomQueryClientProvider from 'context/CustomQueryClientProvider';
import { Provider } from 'context/ModalContext';
import Routes from 'routes';
import { themes } from 'utils';

export type ComponentProps = Record<string, unknown>;

const Wrapper = styled.div`
  @media ${device.isMobile}, ${device.isTablet} {
    background-color: white;
  }
`;

const App: React.FC<ComponentProps> = () => (
  <ThemeProvider theme={themes.primary}>
    <GlobalStyle />
    <Wrapper>
      <Helmet />
      <Provider>
        <CustomQueryClientProvider>
          <Routes />
          {process.env.NODE_ENV !== 'production' && <ReactQueryDevtools initialIsOpen={false} />}
        </CustomQueryClientProvider>
      </Provider>
    </Wrapper>
  </ThemeProvider>
);

export default App;
